module.exports = __webpack_public_path__ + "media/images/unsplash_img_02-p-1080-313f16df6ad39eeb1ae2861f27fed4ef.jpeg";